import { createFileRoute } from "@tanstack/react-router";
import StatisticiAuto from "@/pages/StatisticiAuto";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/auto-statistics/")({
  head: () => routeHead("/uk/auto-statistics/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <StatisticiAuto />
  );
}
